import {
    Dropdown,
    DropdownButtonNew as DropdownButton,
    DropdownContent,
} from '../../Dropdown'

import {
    queueName as queueNameStyles, styledItem,
} from 'components/Dropdown/styles'

import {
    styledButton,
    styledContent,
    styledList,
    styledName,
    styledStatus,
} from 'components/Sidebar/styles'
import Button from '../../Button'
import {HeroVideoCameraIconSolid} from '../../Icon'
import QueueingTimeView from 'components/QueueingTime'
import React from 'react'
import {SidebarAudienceViewProps} from '../types'
import UserAvatar from '../../Avatar/UserAvatar'
import {styled} from 'stitches/config'
import {useTranslation} from 'react-i18next'

const StyledList = styled('li', styledList)
const StyledContent = styled('div', styledContent)
const StyledButton = styled('button', styledButton)
const StyledName = styled('div', styledName)
const StyledStatus = styled('div', styledStatus)
const StyledItem = styled('div', styledItem)
const StyledQueueName = styled('div', queueNameStyles)

const SidebarAudienceView = ({
    channelId,
    loadChannel,
    channelDetails,
    closeConversationModal,
    endConversationModal,
    queueName,
    nested,
    isGroupQueue,
}: SidebarAudienceViewProps): React.ReactElement => {
    const {t} = useTranslation()
    return (
        <StyledList key={channelId} nested={nested}>
            <StyledContent>
                <StyledButton
                    active={channelDetails.isSelected}
                    onClick={loadChannel}
                    type='button'
                >
                    <UserAvatar
                        connected={channelDetails.connected}
                        highlight={channelDetails.channelStatus === 'highlight'}
                        idle={Boolean(channelDetails.idle)}
                        name={channelDetails.name}
                        size='small'
                        src={channelDetails.iconurl}
                        unread={channelDetails.channelStatus === 'unread'}
                    />
                    <StyledName status={channelDetails.channelStatus}>
                        <div>{channelDetails.name}</div>
                        {!nested || isGroupQueue ? <StyledQueueName isGroupQueue={isGroupQueue} status={channelDetails.channelStatus || '' as any}>{queueName}</StyledQueueName> : null}
                    </StyledName>
                    {!!channelDetails.isVideoChannel &&
                    <StyledStatus active={channelDetails.isVideoActive}><span title={t('Video audience')}><HeroVideoCameraIconSolid size={14} /></span></StyledStatus>}
                    {!channelDetails.isClosed && channelDetails.createTime ?
                        <QueueingTimeView
                            queueLength={1}
                            queue_time={channelDetails.createTime}
                            sla={false}
                        />
                        : null}
                </StyledButton>
                <Dropdown>
                    <DropdownButton caret={true} color='text' data-id='dropdown-caret' size='small' />
                    <DropdownContent direction='fixed-end'>
                        <StyledItem>
                            {!channelDetails.isClosed &&
                            <Button
                                color='text'
                                onPress={(): void => endConversationModal()}
                                text={t('End conversation')}
                                title={t('End conversation')}
                                type='button'
                            />}
                            {!!channelDetails.isClosed &&
                            <Button
                                color='text'
                                onPress={(): void => closeConversationModal()}
                                text={t('Close conversation')}
                                title={t('Close conversation')}
                                type='button'
                            />}
                        </StyledItem>
                    </DropdownContent>
                </Dropdown>
            </StyledContent>
        </StyledList>
    )
}
export default SidebarAudienceView
